/**
 * Created by CoolGuy on 2017/4/11.
 */
import React from "react";
import { connect } from "react-redux";
import { Layout, Menu, Breadcrumb, Icon, message, Dropdown, Button, Badge, Drawer } from 'antd';
import Link from '../NavLink';

import IMDetail from '../IM/index.js';

//import moment from 'moment';
import moment from 'moment-timezone';
import 'moment/locale/zh-cn';

import "./index.scss";
import { isWeb, findObjByKey } from '../../util/index';
import AjaxAction from '../../actions/AjaxAction';
import actions from '../../actions/index.js';
import UserPhoto from '../Common/UserPhoto';

const { Header, Content, Footer, Sider } = Layout;
const SubMenu = Menu.SubMenu;
// 东八区 不知道为啥没有北京
moment.tz.setDefault('Asia/Chongqing')
moment.locale('zh-cn');

//url是作为key值，请保持唯一
const menuData = [
    {
        url: "/page/dashboard",
        icon: "pie-chart",
        name: "看板"
    }, {
        url: "ai-sales",
        icon: "customer-service",
        name: "智能助手",
        url: '/page/ai-sales',
        permission: 'gallery-decorate-plus',
    }, {
        url: "1",
        icon: 'user',
        name: '管理',
        permission: 'department-query',
        children: [
            { url: '/page/admin/department', name: '部门与员工' },
            { url: '/page/admin/appupdate', name: 'APP版本', permission: 'app-manage' },
            { url: '/page/admin/notice', name: '公告', permission: 'notice-manage' },
            { url: '/page/admin/log', name: '日志', permission: 'log-manage' }
        ]
    }, {
        url: "/page/product/list",
        icon: 'bars',
        name: "产品",
        permission: 'product-query',
    }, {
        url: "/page/clue/list",
        icon: "phone",
        name: "线索",
        permission: 'clue-query',
    }, /*{
        url: "/page/oppo/list",
        icon: "flag",
        name: "商机",
        permission: 'oppo-query',
    }, */{
        url: "/page/service/list",
        icon: "smile",
        name: "服务人员",
        permission: 'service-query'
    }, {
        url: "/page/order/list",
        icon: "solution",
        name: "订单",
        permission: 'order-query',
    }, {
        url: "/page/tag/list",
        icon: "tag",
        name: "标签",
        permission: 'tag-query',
    }, {
        url: "/page/matter/list",
        icon: "medium",
        name: "案例库",
        permission: 'matter-query'
    }, /*{
        url: "/page/gallery/list",
        icon: "camera-o",
        name: "相册",
        permission: 'gallery-query',
    }, */{
        url: '/page/rate/list',
        icon: 'usergroup-add',
        name: '评价',
        permission: 'rate-query'
    }, {
        url: '/page/person/list',
        icon: 'meh',
        name: '人脸',
        permission: 'person-list'
    }, {
        url: "/page/message/list",
        icon: "star",
        name: "原片",
        permission: 'message-query',
    }, {
        url: "/page/comment/gallery",
        icon: "form",
        name: "评论",
        permission: 'comment-query'
    }, {
        url: '/page/stat/index',
        icon: 'area-chart',
        name: '统计',
        permission: 'stat-query'
    }, window.limit_mode ? null : {
        url: '/agreement/list',
        icon: "exception",
        name: "合同",
        permission: 'agreement-query',
    }, {
        url: "/page/bill/list",
        icon: "file",
        name: "发票",
        permission: 'bill-query',
    }, {
        url: "/page/consumer/list",
        icon: "customer-service",
        name: "客户",
        permission: 'consumer-query',
    }, {
        url: "/page/proxy/list",
        icon: "customer-service",
        name: "代理商",
        permission: 'proxy-query'
    }, {
        url: "/page/contact/list",
        icon: "contacts",
        name: "联系人",
        permission: 'contact-query',
    }, {
        url: "/page/checking/list",
        icon: "check-square",
        name: "对账单",
        permission: "checking-query",
        /*children: [{
            url: "/page/checking/list",
            name: "结算单"
        }, {
            url: "/checking/service",
            name: "服务费支出"
        }]*/
    }, {
        url: "tool",
        icon: "tool",
        name: "工具",
        permission: 'tool-video',
        children: [
            {
                url: "/page/tool/video",
                name: "视频素材",
                permission: 'tool-video'
            },
            {
                url: '/page/tool/domain',
                name: '域名验证',
                permission: 'tool-domain'
            },
            {
                url: '/page/tool/convert',
                name: '表格转换',
                permission: 'tool-convert-table'
            }
        ]
    }, {
        url: "/page/remit/list",
        icon: "pay-circle-o",
        name: "回款",
        permission: 'remit-query'
    }].filter(it => !!it);

class MyLayout extends React.Component {
    state = {
        collapsed: false,
        mode: 'inline',
        hasNewMsg: false,
        init: false
    };
    onCollapse = (collapsed) => {
        this.setState({
            collapsed,
            mode: collapsed ? 'vertical' : 'inline',
        });
    };
    findParentObjOfMenuItem = (key) => {
        let parent = menuData.find((v) => {
            if (v.children) {
                let index = v.children.findIndex((item) => {
                    return item.url === key;
                });
                if (~index) {
                    return true;
                }
            }
            return false;
        });
        if (!parent) {
            return null;
        }
        return parent;
    };

    //目前只支持最多2层，多层需要重新处理
    getCurrentMenuKey = () => {
        let { router } = this.props;
        let { pathname, search } = router.location;
        if (pathname === '/page/ai-sales' && search) {
            return pathname + search;
        }
        return pathname;
    };

    renderBread = () => {
        let pathname = this.getCurrentMenuKey();
        let first = this.findParentObjOfMenuItem(pathname);//有可能是一级目录找不到父级
        let second = "";
        if (!first) {
            first = findObjByKey(menuData, pathname, "url");
        } else {
            let parentKey = first && first.url;
            if (parentKey) {
                second = findObjByKey(first.children, pathname, "url").name;
                //console.log(childrenName);
            }
        }

        return (
            <Breadcrumb style={{ margin: '12px 0' }}>
                <Breadcrumb.Item>{first && first.name}</Breadcrumb.Item>
                {second && <Breadcrumb.Item>{second}</Breadcrumb.Item>}
            </Breadcrumb>
        )

    };

    getTagCategory = () => {
        let { dispatch } = this.props;
        dispatch(AjaxAction.orderTagCategory());
    }

    getImageSign = () => {
        let { dispatch } = this.props;
        dispatch(AjaxAction.imageSign());
    };
    getUserInfo = () => {
        let userId = window.sessionStorage['userId'];
        let { dispatch } = this.props;
        dispatch(AjaxAction.userDetail(userId, 'MYSELF'));
    }
    getPermission = () => {
        let { dispatch } = this.props;
        dispatch(AjaxAction.permissionList())
    }

    getAreaList = () => {
        let { dispatch } = this.props;
        dispatch(AjaxAction.areaList());
    }

    afterLogin() {
        let { user, router, image, myInfo, asyncUserList, dispatch, tagCategory, areaList } = this.props;
        //   let {permissionUserList} = this.props;
        let userId = window.sessionStorage.getItem('userId');
        //!user.userName && dispatch(AjaxAction.currentUser());
        if ((user && user.loggedIn === false) || !userId) {
            // router.history.push("/login");
            this.logout();
        } else {
            var current = router.location;

            let next = () => {
                if (!myInfo || !myInfo.id) {
                    this.getUserInfo();
                }
                //   if (!permissionUserList || !permissionUserList.length) {
                //     this.getPermission();
                //   }
                if (!image || !image.sign) {
                    this.getImageSign();
                }

                //   if(!tagCategory || !Object.keys(tagCategory).length) {
                //     this.getTagCategory();
                //   }

                if (!areaList || !areaList.length) {
                    this.getAreaList();
                }

                if (current.pathname === '/') {
                    router.history.replace('/page/dashboard');
                }
            }
            // if (Object.keys(asyncUserList).length < 400) {
            //     dispatch(AjaxAction.users({
            //         page: 1,
            //         pagesize: 300
            //     })).then(next);
            // } else {
            //     next();
            // }
            next();
        }
    }

    componentWillMount() {
        // let {dispatch,user} = this.props;
        let { dispatch, router } = this.props;
        // this.afterLogin();
        dispatch(AjaxAction.userInfo()).then((res) => {
            if (res && res.id) {
                this.afterLogin();
                this.setState({
                    init: true
                });
            } else {
                // console.log(`登录失败`);
                message.warning('登录已过期，正在跳转至登录界面');
                window.location.href = `/workwechat/login?redirect=${encodeURIComponent(window.location.href)}`;
                // window.location.href = `/login?redirect=${encodeURIComponent(window.location.href)}`;
            }
        });

        if (!isWeb()) {
            document.querySelector('#root').className = 'mobile';
        }
    }

    //检查当前页面是否有权限
    // hasRight = (path) => {
    //     let {permissionUserList} = this.props;
    //     // if (!permissionUserList || !permissionUserList.length) {
    //     //     return true;//如果没有获取到列表，先认为是有权限的
    //     // }
    //     //eslint-disable-next-line
    //     let hasPermission = permissionUserList.findIndex((v) => {
    //         if (v.authorityType === "URL" && v.code === path) {
    //             return true;
    //         }
    //     }) > -1;
    //     return hasPermission;
    // };
    //目前只支持2级权限
    // filterMenu = (menuData) => {
    //     let _this = this;
    //     let newMenuData = [];
    //     //eslint-disable-next-line
    //     menuData.map((first) => {
    //         let {url} = first;
    //         //链接
    //         if (url && url.indexOf("/") === 0) {
    //             if (_this.hasRight(url)) {
    //                 newMenuData.push(first);
    //             }
    //         } else {//非链接看是否有子集，有的话遍历
    //             let {children} = first;
    //             if (children && children.length) {
    //                 newMenuData.push({
    //                     ...first,
    //                     children: _this.filterMenu(children)
    //                 });
    //             } else {
    //                 newMenuData.push(first);
    //             }
    //         }
    //     });
    //     return newMenuData;
    // };
    logout = () => {
        let { dispatch, router } = this.props;
        // router.history.replace('/workwechat/login?logout');
        window.location.href = `/workwechat/login`;
        dispatch(AjaxAction.logout());
        // window.location.href = '/?logout=1#/login';
    };

    bindWeixin = () => {
        var url = encodeURIComponent(window.location.href);
        var rd = `http://wx.jfoto.cn/gallery/login?appid=crm&type=admin&redirect_uri=${url}`;
        window.location.href = rd;
    }

    showIM = () => {
        let { dispatch } = this.props;
        dispatch(actions.showIMDetail(true));

        this.setState({
            hasNewMsg: false
        });
    }

    onNewMsg = () => {
        if (!this.props.imDetailShow) {
            this.setState({
                hasNewMsg: true
            });
        }
    }

    render() {
        let { router/*,user*/, myInfo } = this.props;
        let { hasNewMsg } = this.state;
        let { pathname } = router.location;
        let currentMenuKey = this.getCurrentMenuKey();
        //if(!this.hasRight(pathname)){
        //    //正常情况下不应该走到这里来
        //    window.location.href = "#/login";
        //    return <div>没有权限</div>;
        //}
        let filteredMenuData = menuData;//this.filterMenu(menuData);
        //console.log(menuData,filteredMenuData);
        let menuItem = this.findParentObjOfMenuItem(currentMenuKey);
        let parentKey = menuItem && menuItem.url;

        const fullContent = (pathname || '').indexOf('/page/gallery/decorate') == 0;

        const renderMenu = () => {
            return <Menu theme="dark" mode={this.state.mode} selectedKeys={[currentMenuKey]}
                defaultOpenKeys={[parentKey]}>
                {filteredMenuData.map((v) => {
                    //是否有children
                    let children = v.children;
                    let flag = children && children.length;
                    if (flag) {
                        let visibleChildren = children.filter((item) => {
                            return !window.actionFor(item.permission, 'boolean') || typeof item.permission == 'undefined';
                        });
                        if (!visibleChildren.length) {
                            return null;
                        }
                        return (
                            !window.actionFor(v.permission, 'boolean') || typeof v.permission == 'undefined' ? <SubMenu key={v.url}
                                title={<span>
                                    <Icon type={v.icon} /><span className="nav-text">{v.name}</span>
                                </span>}>
                                {visibleChildren.map((item) => {
                                    return (<Menu.Item key={item.url}>
                                        <Link to={item.url}>{item.name}</Link>
                                    </Menu.Item>)
                                })}
                            </SubMenu> : null
                        )
                    } else {
                        return (
                            !window.actionFor(v.permission, 'boolean') || typeof v.permission == 'undefined' ? <Menu.Item key={v.url}>
                                <Link to={v.url}>
                                    <span>
                                        <Icon type={v.icon} />
                                        <span className="nav-text">{v.name}</span>
                                    </span>
                                </Link>
                            </Menu.Item> : null
                        )
                    }
                })}
            </Menu>;
        };

        //user临时方案，用window.sessionStorage['nickname']
        return this.state.init ? (
            <Layout className="main-layout">
                {isWeb() ? <Sider
                    collapsible={true}
                    collapsed={this.state.collapsed}
                    onCollapse={this.onCollapse}
                    collapsedWidth={0}
                    width={120}
                >
                    <div style={{ height: 64 }} />
                    {renderMenu()}
                </Sider> : <div className="sider-mobile">
                    {this.state.mobileSilder ?
                        <Icon type="menu-fold" onClick={() => this.setState({ mobileSider: false })} /> :
                        <Icon type="menu-unfold" onClick={() => this.setState({ mobileSider: true })} />
                    }
                    <Drawer visible={this.state.mobileSider} className="sider-mobile-drawer" width={208} placement="left" onClose={() => {
                        this.setState({
                            mobileSider: false
                        });
                    }}>
                        {renderMenu()}
                    </Drawer>
                </div>}
                <Layout>
                    <Header style={{ background: '#F4F6FC', textAlign: "right", paddingRight: 20 }}>
                        <a onClick={this.showIM} style={{ lineHeight: '14px', marginRight: '10px' }}><Badge dot={!!hasNewMsg}><Icon style={{ fontSize: '14px', lineHeight: '14px', marginRight: '5px' }} type="message" /></Badge>待办通知</a>
                        <Dropdown overlay={
                            <Menu>
                                <Menu.Item>
                                    <a target="_blank" rel="noopener noreferrer" onClick={this.bindWeixin}>{myInfo.openid ? '更换微信' : '绑定微信'}</a>
                                </Menu.Item>
                                <Menu.Item>
                                    <a target="_blank" rel="noopener noreferrer" onClick={this.logout}>退出</a>
                                </Menu.Item>
                            </Menu>
                        }>
                            {// eslint-disable-next-line
                            }<a className="ant-dropdown-link">
                                <UserPhoto nickname={window.sessionStorage['nickname']} /> {window.sessionStorage['nickname']}
                                <Icon type="down" />
                            </a>
                        </Dropdown>
                    </Header>
                    <Content style={{ margin: '0 0', overflow: 'initial', overflowX: "auto" }}>
                        {/*this.renderBread()*/}
                        <div id="mainWrapper" className={fullContent ? 'fullcontent' : ''}>
                            {this.props.children}
                            <IMDetail onNewMsg={this.onNewMsg} />
                        </div>
                    </Content>
                </Layout>
            </Layout>
        ) : null;
    }
}

export default connect(state => ({
    demo: state.demo,
    im: state.im,
    tagCategory: state.tagCategory,
    // permissionUserList: state.permissionUserList,
    image: state.image,
    myInfo: state.myInfo,
    asyncUserList: state.asyncUserList,
    imDetailShow: state.ui.showIMDetail,
    ui: state.ui
}))(MyLayout);



// WEBPACK FOOTER //
// ./src/components/Layout/index.js